/*
	global androidJs
*/
import axios from 'axios';

import android from '@flyme/jr/js/android.js';
import base64 from './base64.js';
import apis from './apis.js';
import dealPar from './dealPar.js';

// import Mock from './mock/index.js';
// import config from './config';
// import android from './android.js'
if (process.env.NODE_ENV === 'development') {
	// Mock();
}

var instance = axios.create({
	// baseURL: config.baseURL,
	timeout: 30000,
	headers: {
		'accept': 'application/json',
		'content-type': 'application/x-www-form-urlencoded'
	}
});

function toURLParams (data) {
	var params = [];
	for (var i in data) {
		params.push(i + '=' + (data[i] === undefined ? '' : data[i]));
	}
	return params.join('&');
}


let encryApis = [
	apis.acct_bank_get,
	apis.acct_order_create,
	apis.acct_order_prepay,
	apis.acct_order_pay,
	apis.acctplus_order_create,
	apis.acctplus_order_prepay,
	apis.acctplus_order_pay,
	apis.bank_list,
	apis.bank_query,
	apis.bank_sms_code,
	apis.bank_bind,
	apis.support_list
];

let jrpayEncryApis = [
	apis.bank_list,
	apis.bank_query,
	apis.bank_sms_code,
	apis.bank_bind,
	apis.support_list
];

instance.interceptors.request.use(config => {
	if (encryApis.indexOf(config.url) > -1) {
		var data = {
			access_token: window.token,
			version: '1.0'
		};
		if(JSON.stringify(config.data) !== '{}'){
			if (jrpayEncryApis.indexOf(config.url) > -1) {
				data.value = encodeURIComponent(androidJs.doAndroidActionSync("encryptAndSignSync", JSON.stringify({"src": dealPar.encodeURIComponentObj(config.data) })));
			}else{
				data.value = encodeURIComponent(androidJs.doAndroidActionSync("pwdEncryptAndSignSync", JSON.stringify({"src": dealPar.encodeURIComponentObj(config.data) })));
			}
		}
		config.data = toURLParams(data);
		return config;
	}else{
		config.data.access_token = window.token;
		config.data.version = '1.0';
		config.data = toURLParams(config.data);
		return config;
	}
}, error => {
	return Promise.reject(error);
});

instance.interceptors.response.use(response => {
	if (response.data.code === 400) {
		return response.data;
	}else if (response.data.code === 40001) {
		androidJs.doAndroidAction('showNetworkError', '');
		androidJs.doAndroidAction('hideLoadingDialog', '');
	} else {
		if (response.data.code !== 200) {
			return response.data;
		}
		if (encryApis.indexOf(response.config.url) > -1) {
			var decry = '';
			if (jrpayEncryApis.indexOf(response.config.url) > -1) {
				decry = androidJs.doAndroidActionSync("decryptAndVerifySync", JSON.stringify({"src": response.data.value }));
			} else {
				decry = androidJs.doAndroidActionSync("pwdDecryptAndVerifySync", JSON.stringify({"src": response.data.value }));
			}
			response.data.value = JSON.parse(base64.decode(decry));
		}
		return response.data;
	}
}, err => {
	androidJs.doAndroidAction('hideLoadingDialog', '');
	console.error('axios 返回：', err);
	if (err.message.search('401') !== -1) {
		console.log('401 进行重新发送', err);
		android('getToken', {
			isForceUpdate: true
		}, (token) => {
			window.token = token;
			err.config.data.access_token = window.token;
			return axios.request(err);
		});
		return 401;
	}
	if (err.message.search('timeout') !== -1) {
		androidJs.doAndroidAction('showNetworkError', '');
	} else if (err.request.status === '404') {
		androidJs.doAndroidAction('showNoNetwork', '');
	} else if (err.request.status == 0) {
		androidJs.doAndroidAction('showNetworkError', '');
	} else if (err.message.search('Network Error') !== -1) {
		// androidJs.doAndroidAction('showNoNetwork', '');
	} else {
		return err;
	}
});

export default instance;



// WEBPACK FOOTER //
// ./src/axios.js